import { Component } from '@angular/core';

import { FLOCK_VARIANT } from '../../../models/flock.model';
import { FlockOverviewVariantConfig } from '../../shared/flock-variant.config';

export const LAYER_FLOCK_OVERVIEW_CONFIG: FlockOverviewVariantConfig = {
  flockVariant: FLOCK_VARIANT.Layer,
  newFlockTranslationKey: 'flock-overview.new-flock',
  deleteFlockTranslationKey: 'flock-overview.panel.delete',
  showLayerActions: true,
  showBreederFields: false,
  loadRearingOrganizations: false,
  arrivalDetail: {
    flockVariant: FLOCK_VARIANT.Layer,
    productionPeriod: {
      startInDays: 141,
      startWeekNr: 21,
    },
  },
  weekRegistration: {
    productionPeriod: {
      startInDays: 141,
      startWeekNr: 21,
    },
  },
};

@Component({
  selector: 'app-layer-flock-overview',
  templateUrl: './layer-flock-overview.component.html',
  standalone: false,
})
export class LayerFlockOverviewComponent {
  readonly config = LAYER_FLOCK_OVERVIEW_CONFIG;
}
